import React from 'react';
import PropTypes from 'prop-types';

const Button = (props) => {
  const { onClick, color, disabled, title, idName, icon, textColor, style = {} } = props
  return (
    <button
      onClick={onClick}
      className={`button ${color ? `button-is--${color}` : ''}`}
      style={{ backgroundColor: color ?? '#68C9D0', ...style }}
      id={idName ?? ''}
      disabled={disabled}>
      <span style={{color: textColor}}>{title}</span>
      {icon && icon}
    </button>
  )
}

Button.propTypes = {
  title: PropTypes.any,
  color: PropTypes.string
}

export default Button;
